<template>
  <div class="registration-details" v-loading="loading">
    <div class="page-title">报名详情</div>

    <div class="detail-card">
      <div class="card-header" @click="goBack">
        <i class="el-icon-arrow-left"></i> <span>返回</span>
      </div>
      <div class="detail-block">
        <div class="block-title">
          <span class="left-line"></span>
          <span>{{ exam.name || "-" }}</span>
        </div>

        <div class="info-row">
          <span class="label">报名时间：</span>
          <span class="value">{{ formatDateRange(exam.enrollStartTime, exam.enrollEndTime) }}</span>
        </div>

        <div class="divider"></div>

        <div class="info-row">
          <span class="label">理论学习时间：</span>
          <span class="value">{{ formatDateRange(exam.examStartTime, exam.examEndTime) }}</span>
        </div>
      </div>

      <div class="detail-block">
        <div class="block-title">
          <span class="left-line"></span>
          <span>报名信息</span>
        </div>

        <div class="info-row">
          <span class="label">报名费用：</span>
          <span class="value">{{ feeText }}</span>
        </div>

        <div class="divider"></div>

        <div class="info-row">
          <span class="label">报名状态：</span>
          <span class="value" :class="signupStatusClass">{{ signupStatusText }}</span>
        </div>
      </div>

      <div class="detail-block intro-block">
        <div class="block-title">
          <span class="left-line"></span>
          <span>考试介绍</span>
        </div>

        <div class="intro-content" v-html="exam.content || '暂无介绍'"></div>
      </div>
    </div>

    <div class="action-wrap" v-if="showActionButton">
      <el-button
        v-if="actionDisabled"
        round
        disabled
        class="signup-btn signup-btn-disabled"
      >
        {{ actionDisabledText }}
      </el-button>
      <el-button
        v-else
        type="primary"
        round
        class="signup-btn"
        @click="handleActionClick"
      >
        <span class="btn-label">{{ actionMainText }}</span>
        <span v-if="showActionPrice" class="btn-price">￥{{ formatPrice(currentPrice) }}</span>
      </el-button>
    </div>

    <el-dialog
      title="隐私政策提示"
      width="520px"
      :visible.sync="privacyDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="privacy-tips">
        欢迎使用e护考培，请您在使用前认真阅读
        <el-link href="/#/userProtocol" class="privacy-link" target="_blank" type="primary"
          >《用户协议》</el-link
        >
        和
        <el-link href="/#/privacy" class="privacy-link" target="_blank" type="primary"
          >《隐私政策》</el-link
        >，点击“同意并继续”即表示您已阅读并同意全部条款，可继续使用本软件。
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" round class="agree-btn" @click="agreeAndContinue">
          同意并继续
        </el-button>
        <div class="disagree-btn" @click="privacyDialogVisible = false">不同意</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";
import { resolveEnrollOperationState } from "@/utils/enrollCheckFlow";

export default {
  name: "RegistrationDetails",
  data() {
    return {
      loading: false,
      privacyDialogVisible: false,
      userInfo: null,
      exam: {
        erId: null,
        name: "",
        content: "",
        enrollStartTime: "",
        enrollEndTime: "",
        examStartTime: "",
        examEndTime: "",
        firstTimePrice: null,
        renewalPrice: null,
        willExamType: null,
        apply: null
      }
    };
  },
  computed: {
    isXQ() {
      const val = Number(this.$route.query.isXQ);
      return Number.isNaN(val) ? 0 : val;
    },
    showActionButton() {
      return this.isXQ !== 1;
    },
    operationState() {
      return resolveEnrollOperationState(this.exam, this.userInfo);
    },
    isEnrolled() {
      return this.operationState === "enrolled";
    },
    isAuditing() {
      return this.operationState === "auditing";
    },
    actionDisabled() {
      return this.isEnrolled || this.isAuditing;
    },
    actionDisabledText() {
      if (this.isEnrolled) {
        return "已报名";
      }
      if (this.isAuditing) {
        return "审核中";
      }
      return "";
    },
    actionMainText() {
      if (this.operationState === "reapply") {
        return "重新报名";
      }
      if (this.operationState === "enroll_apply") {
        return "立即报名";
      }
      return this.trainingTypeText;
    },
    showActionPrice() {
      return this.operationState === "wait_pay" || this.operationState === "enroll_pay";
    },
    currentExamType() {
      if (
        this.exam.apply &&
        this.exam.apply.examType !== null &&
        this.exam.apply.examType !== undefined
      ) {
        return Number(this.exam.apply.examType);
      }
      if (this.exam.willExamType !== null && this.exam.willExamType !== undefined) {
        return Number(this.exam.willExamType);
      }
      if (this.exam.examType !== null && this.exam.examType !== undefined) {
        return Number(this.exam.examType);
      }
      return 0;
    },
    currentPrice() {
      const first = this.exam.firstTimePrice;
      const renewal = this.exam.renewalPrice;
      if (this.currentExamType === 1) {
        return renewal !== null && renewal !== undefined ? renewal : first;
      }
      return first !== null && first !== undefined ? first : renewal;
    },
    trainingTypeText() {
      return this.currentExamType === 1 ? "换证培训" : "初次培训";
    },
    feeText() {
      const price = this.currentPrice;
      if (price === null || price === undefined || price === "") {
        return "-";
      }
      return `${this.formatPrice(price)}元`;
    },
    signupStatusText() {
      switch (this.operationState) {
        case "enrolled":
          return "已报名";
        case "auditing":
          return "审核中";
        case "wait_pay":
          return "待缴费";
        case "reapply":
          return "已驳回";
        case "enroll_apply":
        case "enroll_pay":
          return "未报名";
        default:
          break;
      }
      return "未报名";
    },
    signupStatusClass() {
      const status = this.signupStatusText;
      if (status === "已报名") {
        return "status-enrolled";
      }
      if (status === "审核中") {
        return "status-auditing";
      }
      if (status === "待缴费") {
        return "status-wait-pay";
      }
      if (status === "已驳回") {
        return "status-rejected";
      }
      return "status-default";
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.loadDetail();
      }
    }
  },
  created() {
    this.restoreUserFromCache();
    this.loadUserInfo({ silent: true });
    this.loadDetail();
  },
  methods: {
    restoreUserFromCache() {
      try {
        const cached = localStorage.getItem("pc_user");
        if (cached) {
          this.userInfo = JSON.parse(cached);
        }
      } catch (error) {
        this.userInfo = null;
      }
    },
    async loadUserInfo({ silent = false } = {}) {
      try {
        const res = await httpRequest("/app/user", "get", null);
        if (res && res.code === 200) {
          this.userInfo = res.data || null;
          localStorage.setItem("pc_user", JSON.stringify(res.data || {}));
          return true;
        }
      } catch (error) {
        if (!silent) {
          this.$message.warning("获取用户信息失败，请稍后重试");
        }
      }
      return false;
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
    async loadDetail() {
      const erId = Number(this.$route.query.erId);
      if (Number.isNaN(erId) || erId <= 0) {
        this.$message.error("考试参数异常");
        return;
      }

      this.loading = true;
      try {
        const res = await httpRequest("/app/exam/exam/userExamInfo", "get", {
          erId
        });
        if (res && res.code === 200 && res.data) {
          this.exam = res.data;
        }
      } finally {
        this.loading = false;
      }
    },
    async handleActionClick() {
      if (this.actionDisabled) {
        return;
      }
      if (!this.exam || !this.exam.erId) {
        return;
      }
      if (
        this.showActionPrice &&
        (this.currentPrice === null || this.currentPrice === undefined)
      ) {
        this.$message.error("报名费用异常，请稍后重试");
        return;
      }
      const loaded = await this.loadUserInfo();
      if (!loaded || !this.userInfo) {
        this.$message.warning("请先登录");
        return;
      }
      if (Number(this.userInfo.authStatus) !== 2) {
        this.promptRealNameDialog();
        return;
      }
      this.privacyDialogVisible = true;
    },
    async promptRealNameDialog() {
      try {
        await this.$confirm(
          "当前报名需先完成实名认证，是否立即前往实名认证？",
          "实名认证提醒",
          {
            confirmButtonText: "立即实名",
            cancelButtonText: "暂不实名",
            type: "warning",
            closeOnClickModal: false
          }
        );
        this.$router.push("/realName");
      } catch (error) {
        // 用户取消，不继续跳转
      }
    },
    agreeAndContinue() {
      if (!this.exam || !this.exam.erId) {
        return;
      }
      this.privacyDialogVisible = false;
      if (this.operationState === "enroll_apply" || this.operationState === "reapply") {
        this.$router.push({
          path: "/registrationApply",
          query: {
            erId: this.exam.erId
          }
        });
        return;
      }
      const price = this.formatPrice(this.currentPrice);
      this.$router.push({
        path: "/newApplyInvoice",
        query: {
          erId: this.exam.erId,
          price,
          ismine: "1"
        }
      });
    },
    formatPrice(price) {
      const num = Number(price);
      if (Number.isNaN(num)) {
        return "-";
      }
      if (Number.isInteger(num)) {
        return String(num);
      }
      return num.toFixed(2).replace(/\.00$/, "");
    },
    formatDate(dateStr) {
      if (!dateStr) {
        return "-";
      }
      const raw = String(dateStr).trim();
      if (raw.length >= 10) {
        return raw.slice(0, 10).replace(/-/g, "/");
      }
      return raw.replace(/-/g, "/");
    },
    formatDateRange(start, end) {
      if (!start && !end) {
        return "-";
      }
      return `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
    }
  }
};
</script>

<style scoped lang="scss">
.registration-details {
  width: 1200px;
  margin: 18px auto 0;
  text-align: left;
  min-height: calc(100vh - 77px - 100px - 18px);
  padding-bottom: 24px;

  .page-title {
    text-align: center;
    color: #1e295b;
    font-size: 26px;
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: 24px;
  }

  .detail-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    padding: 30px 50px 40px;
    margin-bottom: 30px;
    position: relative;
  }

  .card-header {
    display: inline-flex;
    align-items: center;
    font-size: 15px;
    color: #515a67;
    cursor: pointer;
    margin-bottom: 24px;
    transition: color 0.2s ease;

    i {
      font-size: 18px;
      margin-right: 4px;
    }

    &:hover {
      color: #3f93dc;
    }
  }

  .detail-block {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .block-title {
      height: 32px;
      display: flex;
      align-items: center;
      color: #1f2530;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 16px;

      .left-line {
        width: 4px;
        height: 16px;
        background: #3f93dc;
        margin-right: 12px;
        border-radius: 2px;
      }
    }

    .info-row {
      display: flex;
      align-items: center;
      color: #344054;
      font-size: 15px;
      padding: 16px 0;
      line-height: 1.5;

      .label {
        color: #8e99a6;
        min-width: 110px;
      }

      .value {
        color: #1f2530;
        font-weight: 500;
      }
      
      .status-enrolled {
        color: #0ab284;
        font-weight: 600;
      }
    }

    .divider {
      border-top: 1px dashed #e4e7ed;
      margin: 0;
    }
  }

  .intro-block {
    margin-top: 40px;
    
    .block-title {
      margin-bottom: 20px;
    }

    .intro-content {
      color: #344054;
      line-height: 1.8;
      font-size: 15px;
      background: #f8fafc;
      padding: 24px;
      border-radius: 8px;
      border: 1px solid #edf0f4;
    }
  }

  .action-wrap {
    margin-top: 36px;
    display: flex;
    justify-content: center;

    .signup-btn {
      width: 380px;
      height: 52px;
      font-size: 16px;
      font-weight: 600;
      background: #3f93dc;
      border-color: #3f93dc;
      border-radius: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      box-shadow: 0 4px 12px rgba(63, 147, 220, 0.3);
      transition: all 0.2s ease;

      &:hover {
        background: #50a1e8;
        border-color: #50a1e8;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(63, 147, 220, 0.4);
      }

      &:active {
        transform: translateY(1px);
        box-shadow: 0 2px 6px rgba(63, 147, 220, 0.2);
      }

      .btn-label {
        font-size: 16px;
      }

      .btn-price {
        font-size: 18px;
        line-height: 1;
      }
    }

    .signup-btn-disabled {
      background: #f1f3f6 !important;
      border-color: #e4e7ed !important;
      color: #8e99a6 !important;
      cursor: not-allowed;
      box-shadow: none;
      
      &:hover, &:active {
        transform: none;
        box-shadow: none;
      }
    }
  }

  .status-auditing {
    color: #8a9099;
    font-weight: 600;
  }

  .status-wait-pay {
    color: #2567ce;
    font-weight: 600;
  }

  .status-rejected {
    color: #f56c6c;
    font-weight: 600;
  }

  .status-default {
    color: #1f2530;
    font-weight: 500;
  }

  .privacy-tips {
    color: #60656f;
    font-size: 15px;
    line-height: 1.9;
  }

  .privacy-link {
    margin: 0 2px;
  }

  .dialog-footer {
    text-align: center;
    padding-top: 6px;

    .agree-btn {
      width: 240px;
      height: 42px;
      border-radius: 24px;
      background: #3f8eea;
      border-color: #3f8eea;
      font-size: 16px;
      margin-bottom: 14px;
    }

    .disagree-btn {
      color: #8d94a0;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
      line-height: 20px;
    }
  }

  ::v-deep .el-dialog {
    border-radius: 16px;
    overflow: hidden;
  }
}
</style>
